(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-product-layout"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(scope) {
    var galleries = (scope || document).querySelectorAll('[data-ff-gallery]');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.ffReady === 'true') return;
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-ff-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ff-thumb]'));
      var counter = gallery.querySelector('[data-ff-counter]');
      var previous = gallery.querySelector('[data-ff-prev]');
      var next = gallery.querySelector('[data-ff-next]');
      if (!slides.length) return;
      var current = 0;
      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === current);
        });
        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.classList.toggle('is-active', thumbIndex === current);
          thumb.setAttribute('aria-current', thumbIndex === current ? 'true' : 'false');
            if (thumbIndex === current && window.ffThumbSync) window.ffThumbSync(thumb);
        });
        if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          show(Number(thumb.getAttribute('data-ff-thumb')));
        });
      });
      if (previous) previous.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      gallery.dataset.ffReady = 'true';
      show(0);
    });
  }
  function initQuantityGuard(scope) {
    var forms = (scope || document).querySelectorAll('.ff-pdp__form');
    forms.forEach(function (form, formIndex) {
      if (form.dataset.ffQuantityGuard === 'true') return;
      var input = form.querySelector('input[name="quantity"]');
      var field = form.querySelector('.ff-pdp__field--quantity');
      var addButton = form.querySelector('.ff-pdp__add');
      if (!input || !field || !addButton) return;
      var warning = document.createElement('p');
      warning.className = 'ff-pdp__bulk-warning';
      warning.id = 'FFBulkWarning-' + formIndex;
      warning.setAttribute('role', 'alert');
      warning.hidden = true;
      warning.textContent = 'Purchase for B2B or FF Par please visit Robot Fleet Portal';
      field.insertAdjacentElement('afterend', warning);
      function isBlocked() {
        return Number(input.value) >= 10;
      }
      function updateState() {
        var blocked = isBlocked();
        form.classList.toggle('is-bulk-quantity', blocked);
        warning.hidden = !blocked;
        addButton.disabled = blocked;
        input.setAttribute('aria-invalid', blocked ? 'true' : 'false');
        if (blocked) input.setAttribute('aria-describedby', warning.id);
        else input.removeAttribute('aria-describedby');
        form.querySelectorAll('.shopify-payment-button__button').forEach(function (button) {
          button.disabled = blocked;
          button.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        });
      }
      input.addEventListener('input', updateState);
      input.addEventListener('change', updateState);
      form.addEventListener('submit', function (event) {
        if (isBlocked()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          updateState();
        }
      }, true);
      form.addEventListener('click', function (event) {
        if (isBlocked() && event.target.closest('.shopify-payment-button__button')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          updateState();
        }
      }, true);
      new MutationObserver(updateState).observe(form, { childList: true, subtree: true });
      form.dataset.ffQuantityGuard = 'true';
      updateState();
    });
  }
  function init(scope) {
    initGallery(scope);
    /* 9/11 Fiona:数量 ≥10 的 B2B 提示先去掉,9/19 再加(届时集合页、购物车也要补上)。恢复:取消下一行的注释 */
    // initQuantityGuard(scope);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
